import { Col, Row } from '@maternity/mun-layout';
import { Anchor } from '@maternity/mun-router';
import * as React from 'react';

import thankYouPersonImgUrl from '../../images/signup/thank-you-person.jpg';

export function ThankYou() {
  return (
    <Row className="thank-you">
      <Col sm={6} lg={4} lgOffset={2}>
        <h1>Thank You!</h1>
        <p>
          Check your email for instructions on how to log in to your new MN
          account. If you did not receive an email, check your spam folder. If
          you have any further questions, or you do not receive an email,
          contact us at{' '}
          <Anchor href="mailto:sales@quiltedhealth.com">
            sales@quiltedhealth.com
          </Anchor>
        </p>
      </Col>
      <Col sm={6} lg={4}>
        <img
          className="thank-you-person-img hidden-xs"
          src={thankYouPersonImgUrl}
        />
      </Col>
    </Row>
  );
}
